import React, { useState } from 'react'

const ICONS = [
  { name: 'wifi', label: 'WiFi', path: 'M8.111 16.404a5.5 5.5 0 0 1 7.778 0M12 20h.01M1.394 9.393a13.946 13.946 0 0 1 21.212 0M5.636 12.636a9 9 0 0 1 12.728 0' },
  { name: 'monitor', label: 'Screen', path: 'M20 3H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM8 21h8M12 17v4' },
  { name: 'music', label: 'Music', path: 'M9 18V5l12-2v13M9 18a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm12-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0z' },
  { name: 'mic', label: 'Microphone', path: 'M12 1a4 4 0 0 0-4 4v7a4 4 0 0 0 8 0V5a4 4 0 0 0-4-4zM19 10v2a7 7 0 0 1-14 0v-2M12 19v4M8 23h8' },
  { name: 'volume-2', label: 'Sound', path: 'M11 5 6 9H2v6h4l5 4V5zM19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07' },
  { name: 'wine', label: 'Bar', path: 'M8 22h8M12 17v5M7.5 2h9l-1 8a5.5 5.5 0 0 1-11 0L7.5 2z' },
  { name: 'utensils', label: 'Catering', path: 'M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2M7 2v20M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3zm0 0v7' },
  { name: 'car', label: 'Parking', path: 'M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9L18 10l-2.7-3.4A2 2 0 0 0 13.7 6H10l-2 .9L5.7 6a2 2 0 0 0-1.6.8L1.5 10.1C.7 10.3 0 11.1 0 12v3c0 .6.4 1 1 1h2M7.5 17a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM16.5 17a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z' },
  { name: 'sun', label: 'Outdoor', path: 'M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z' },
  { name: 'wind', label: 'Air Con', path: 'M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2M9.6 4.6A2 2 0 1 1 11 8H2M12.6 19.4A2 2 0 1 0 14 16H2' },
  { name: 'accessibility', label: 'Accessible', path: 'M12 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM16 22l-2-6H10l-2 6M12 8v4M8 12h8' },
  { name: 'shirt', label: 'Cloakroom', path: 'M20.38 3.46 16 2 12 5 8 2 3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z' },
  { name: 'calendar', label: 'Events', path: 'M19 4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM16 2v4M8 2v4M3 10h18' },
  { name: 'users', label: 'Capacity', path: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75' },
  { name: 'star', label: 'Premium', path: 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z' },
  { name: 'flag', label: 'Golf', path: 'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1zM4 22v-7' },
  { name: 'coffee', label: 'Coffee', path: 'M18 8h1a4 4 0 0 1 0 8h-1M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8zM6 1v3M10 1v3M14 1v3' },
  { name: 'tv', label: 'TV/Display', path: 'M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM17 2l-5 5-5-5' },
  { name: 'camera', label: 'Photo Area', path: 'M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2zM12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8z' },
  { name: 'flame', label: 'Fireplace', path: 'M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z' },
  { name: 'baby', label: 'Family', path: 'M9 12h.01M15 12h.01M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zM8 15s1.5 2 4 2 4-2 4-2' },
  { name: 'shield-check', label: 'Security', path: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10zM9 12l2 2 4-4' },
  { name: 'sparkles', label: 'Luxury', path: 'M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3zM5 19l.88 2.63L8.5 22.5l-2.63.88L5 26l-.88-2.63L1.5 22.5l2.63-.88L5 19zM19 16l.88 2.63L22.5 19.5l-2.63.88L19 23l-.88-2.63L15.5 19.5l2.63-.88L19 16z' },
  { name: 'zap', label: 'Charging', path: 'M13 2 3 14h9l-1 8 10-12h-9l1-8z' },
  { name: 'trees', label: 'Garden', path: 'M12 13V22M5 22h14M12 3l7 10H5l7-10z' },
]

export default function IconPicker({ value, onChange }) {
  const [search, setSearch] = useState('')

  const filtered = search
    ? ICONS.filter(i =>
        i.name.includes(search.toLowerCase()) ||
        i.label.toLowerCase().includes(search.toLowerCase())
      )
    : ICONS

  return (
    <div>
      <input
        type="text"
        placeholder="Search icons..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="w-full rounded-md border-gray-300 text-sm mb-3 focus:border-sky-500 focus:ring-sky-500"
      />
      <div className="grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-8 gap-2 max-h-64 overflow-y-auto">
        {filtered.map((icon) => (
          <button
            key={icon.name}
            type="button"
            onClick={() => onChange(value === icon.name ? '' : icon.name)}
            className={`flex flex-col items-center gap-1 p-2 rounded-lg border text-xs transition ${
              value === icon.name
                ? 'border-sky-500 bg-sky-50 text-sky-700 ring-1 ring-sky-500'
                : 'border-gray-200 text-gray-600 hover:border-gray-300 hover:bg-gray-50'
            }`}
            title={icon.label}
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
              <path d={icon.path} />
            </svg>
            <span className="truncate w-full text-center">{icon.label}</span>
          </button>
        ))}
      </div>
      {value && (
        <p className="text-xs text-gray-500 mt-2">
          Selected: <code className="bg-gray-100 px-1 rounded">{value}</code>
        </p>
      )}
    </div>
  )
}
